import { extend } from '../../vue';
import { NAME_TABLE_LITE } from '../../constants/components';
import { sortKeys } from '../../utils/object';
import { makePropsConfigurable } from '../../utils/props';
import { attrsMixin } from '../../mixins/attrs';
import { hasListenerMixin } from '../../mixins/has-listener';
import { props as props$1, idMixin } from '../../mixins/id';
import { normalizeSlotMixin } from '../../mixins/normalize-slot';
import { props as props$2, captionMixin } from './helpers/mixin-caption';
import { props as props$3, colgroupMixin } from './helpers/mixin-colgroup';
import { props as props$4, itemsMixin } from './helpers/mixin-items';
import { props as props$5, stackedMixin } from './helpers/mixin-stacked';
import { props as props$6, tableRendererMixin } from './helpers/mixin-table-renderer';
import { props as props$7, tbodyMixin } from './helpers/mixin-tbody';
import { props as props$8, tfootMixin } from './helpers/mixin-tfoot';
import { props as props$9, theadMixin } from './helpers/mixin-thead';

// --- Props ---

const props = makePropsConfigurable(sortKeys({
  ...props$1,
  ...props$2,
  ...props$3,
  ...props$4,
  ...props$5,
  ...props$6,
  ...props$7,
  ...props$8,
  ...props$9
}), NAME_TABLE_LITE);

// --- Main component ---

// @vue/component
const BTableLite = /*#__PURE__*/extend({
  name: NAME_TABLE_LITE,
  // Order of mixins is important!
  // They are merged from first to last, followed by this component
  mixins: [
  // General mixins
  attrsMixin, hasListenerMixin, idMixin, normalizeSlotMixin,
  // Required table mixins
  itemsMixin, tableRendererMixin, stackedMixin, theadMixin, tfootMixin, tbodyMixin,
  // Table features mixins
  // These are pretty lightweight, and are useful for lightweight tables
  captionMixin, colgroupMixin],
  props

  // Render function is provided by `tableRendererMixin`
});

export { BTableLite, props };
